import React from "react";

function Blogs(props) {
  const BlogData = [
    {
      id: 1,
      title: "Organising my first event as a Coding Blocks Superhero ",
      image: "https://miro.medium.com/max/400/1*Z8gH9lnkxWpkgrDyWfDWlA.png",
      link: "https://medium.com/coding-blocks/coderush-96dd82f60f49?source=friends_link&sk=e49b0f5bd3f965295dd49b91ab2e2f94",
    },
    {
      id: 2,
      title: "Fake News Classifier using LSTM",
      image: "https://colah.github.io/images/post-covers/lstm.png",
      link: "https://medium.com/analytics-vidhya/fake-news-classifier-using-lstm-280518f973f7?source=friends_link&sk=6e5c3826d1b296e64fb88e55a73009c2",
    },
    {
      id: 3,
      title: "Understanding Transfer Learning & Image Augmentation",
      image:
        "https://freecontent.manning.com/wp-content/uploads/Elgendy_tCVPp3_03.png",
      link: "https://medium.com/coding-blocks/coderush-96dd82f60f49?source=friends_link&sk=e49b0f5bd3f965295dd49b91ab2e2f94",
    },
  ];

  return (
    <div id="blogs" className="blog" data-aos={"fade-right"}>
      <span className="blog__span">Blogs ✏️</span>
      <div className="container">
        <div className="row">
          {BlogData.map((blog) => {
            return (
              <div key={blog.id} className="blog__container col-md-12 col-lg-4">
                <div className="blog__image my-5">
                  <img src={blog.image} alt="" />
                  <div className="blog__text">{blog.title}</div>

                  <a href={blog.link} target="_blank" rel="noreferrer">
                    <button className="project__button">
                      <div className="row">
                        <div className="col my-auto">
                          <span>Explore</span>
                        </div>
                        <div className="col">
                          <i className="fab fa-lg fa-medium-m"></i>
                        </div>
                      </div>
                    </button>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Blogs;
